import React from 'react';

const publicUrl = window.location.origin; // process.env.PUBLIC_URL;
const backgroundBgWithShadow = `${publicUrl}/background-bg-with-shadow.png`;
const logoIcon = `${publicUrl}/city-info-logo-pdf.png`;

interface ProposalAreaOfferedProps {
    groupedProperties: any[];
    index: number;
    propertyData: any;
    splitFloorOffered: (groupedProperties: { floorOffered: number; totalBuiltArea: number; }[]) => { floorOffered: number; totalBuiltArea: number; }[][];
}

export default function ProposalAreaOffered({ groupedProperties,
    index,
    propertyData,
    splitFloorOffered }: ProposalAreaOfferedProps) {
    return (
        <>
            {groupedProperties.length > 7 &&
                <table className="table-outer-area page-break"
                    style={{
                        // backgroundImage: `url(${require("../../../assets/images/proposal/background-bg-with-shadow.png")})`,
                        backgroundImage: `url(${backgroundBgWithShadow})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "bottom",
                        backgroundSize: "cover",
                        marginTop: "15px",
                        minHeight: "794px",
                    }}
                    width="100%"
                    cellPadding="10"
                    cellSpacing="0"
                >
                    <tbody>
                        <tr>
                            <td align="right">
                                <img
                                    width={110}
                                    src={logoIcon}
                                    alt="property image"
                                />
                            </td>
                        </tr>

                        <tr>
                            <td width="100%" className="pl-40"
                                style={{
                                    color: "#021D77",
                                    marginTop: "-57px",
                                    display: "block",
                                }}
                            >
                                <span style={{ fontSize: "18px" }}>
                                    O P T I O N {index + 1}
                                </span>
                                <br />
                                <div style={{ display: 'flex', }}>
                                    <strong
                                        style={{ fontSize: "25px", fontWeight: 700, maxWidth: '80%', flexShrink: 0 }}
                                    >
                                        {propertyData?.propertyName?.toUpperCase()}
                                    </strong>
                                    <div style={{ height: '4px', width: '100%', backgroundColor: '#C39864', marginTop: '18px', marginLeft: '10px' }}></div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "0" }}>
                                <table cellPadding="0" cellSpacing="0" width="100%">
                                    <tbody>
                                        <tr>
                                            <td valign="top" width="100%">
                                                <table
                                                    width="100%"
                                                    cellPadding="30"
                                                    cellSpacing="0"
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <table
                                                                    width="100%"
                                                                    cellPadding="0"
                                                                    cellSpacing="0"
                                                                >
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <span
                                                                                    style={{
                                                                                        fontSize: "22px",
                                                                                        color: "#8FA9D4",
                                                                                        fontWeight: 700,
                                                                                    }}
                                                                                >
                                                                                    <u> FLOOR & OFFICE AREA OFFERED (In Sq. Ft.)</u>
                                                                                </span>
                                                                            </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td height="10"></td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td
                                                                                style={{
                                                                                    // padding: "20px",
                                                                                    // borderRadius: "12px",
                                                                                    // background: `url(${require("../../../assets/images/proposal/box-shadow.png")})`,
                                                                                    // backgroundPosition: "bottom 0 center",
                                                                                    // backgroundSize: "200%",
                                                                                    // backgroundColor:
                                                                                    //   "#F8F5FA",
                                                                                    // boxShadow:
                                                                                    //   "0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 10px 20px 0 rgba(0, 0, 0, 0.19)",
                                                                                    position: "relative"
                                                                                }}
                                                                            >
                                                                                <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "20px" }}>
                                                                                    {splitFloorOffered(groupedProperties).map((chunk, idx) => <div style={{
                                                                                        position: "relative",
                                                                                        width: "31%"
                                                                                    }} key={idx}>
                                                                                        <div style={{ padding: "20px", borderRadius: "12px", position: 'relative', zIndex: 1, backgroundColor: "#F8F5FA", height: "100%" }}>
                                                                                            <table
                                                                                                width="100%"
                                                                                                cellPadding="0"
                                                                                                cellSpacing="0"
                                                                                            >
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <td valign="top">
                                                                                                            <ul
                                                                                                                style={{
                                                                                                                    listStyleType:
                                                                                                                        "none",
                                                                                                                    padding: "0",
                                                                                                                    marginBottom:
                                                                                                                        "0",
                                                                                                                }}
                                                                                                            >
                                                                                                                {chunk
                                                                                                                    ?.map(
                                                                                                                        (item: {
                                                                                                                            floorOffered: number;
                                                                                                                            totalBuiltArea: number;
                                                                                                                        }) => (
                                                                                                                            <li style={{
                                                                                                                                color:
                                                                                                                                    "#5E5E5E",
                                                                                                                                marginBottom: "4px",
                                                                                                                                justifyContent: "space-between",
                                                                                                                                display: "flex",
                                                                                                                                fontSize: "14px",
                                                                                                                            }}>

                                                                                                                                {/* {getFloorLabel(
                                                                      item.floorNumber
                                                                    )} */}
                                                                                                                                {item?.floorOffered}
                                                                                                                                <span className="text-dark" style={{ fontSize: "14px" }}>
                                                                                                                                    {/* {item.unitArea.toFixed(
                                                                          2
                                                                        )} */}
                                                                                                                                    :{item?.totalBuiltArea}
                                                                                                                                </span>
                                                                                                                            </li>
                                                                                                                        )
                                                                                                                    )}
                                                                                                            </ul>
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                        <div
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                height: "20px",
                                                                                                background:
                                                                                                    "radial-gradient(black, #000000a3)",
                                                                                                position: "absolute",
                                                                                                left: "-50%",
                                                                                                bottom: "-10px",
                                                                                                zIndex: 0,
                                                                                                borderRadius: "147px",
                                                                                                filter: "blur(7px)",
                                                                                                transform:
                                                                                                    "translateX(50%) scaleY(0.2)",
                                                                                            }}
                                                                                        ></div>
                                                                                    </div>)}
                                                                                </div>
                                                                                {/* <div style={{position: 'absolute', bottom: '-9px', left: '-36px', right: '-20px', zIndex: 0}}>
                                            <img src={bottomShadow} alt="" style={{width: '100%'}} />
                                            </div> */}
                                                                                {/* <div
                                              style={{
                                                width: "100%",
                                                height: "20px",
                                                background:
                                                  "radial-gradient(black, #000000a3)",
                                                position: "absolute",
                                                left: "-50%",
                                                bottom: "-10px",
                                                zIndex: 0,
                                                borderRadius: "147px",
                                                filter: "blur(7px)",
                                                transform:
                                                  "translateX(50%) scaleY(0.2)",
                                              }}
                                            ></div> */}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <td height="30"></td>
                        </tr>
                        <tr>
                            <td
                                height="50"
                                style={{ backgroundColor: "#021D77" }}
                            ></td>
                        </tr>
                    </tbody>
                </table>
            }
        </>
    );
}
